import client from './client';

export const dashboardApi = {
  getStats: () => client.get('/dashboard/stats'),
  getNewUsersThisWeek: () => client.get('/dashboard/new-users-week'),
  getActiveUsersToday: () => client.get('/dashboard/active-users-today'),
  getActiveUsersWeek: () => client.get('/dashboard/active-users-week'),
  getLoginsThisWeek: () => client.get('/dashboard/logins-week'),
  getPageVisits: () => client.get('/dashboard/page-visits'),
  getAIActiveUsers: (days = 30) => client.get('/dashboard/ai-active-users', { params: { days } }),
  getProductUsers: (productName) => client.get(`/dashboard/product-users/${encodeURIComponent(productName)}`)
};
